import React, { Component } from 'react';
import { Card, message, Table } from 'antd';
import { queryMaterialDocumentType } from '@api/administrative/material';
import { queryFilePreview } from '@api/pub/attachment';

import moment from 'moment';
import '../../expenses.less';
import DescriptionList from '@comm/DescriptionList';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {
    this.getMaterialDocumentType();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  // 获取资料类型
  getMaterialDocumentType = () => {
    queryMaterialDocumentType().then(res => {
      if (res.statusCode !== 200) {
        message.error(res.message);
      }
    });
  };

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  columns = () => {
    const { dataItem } = this.state;
    return [
      {
        title: '文件编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => {
          const waterMark =
            +dataItem.instance.status === 1
              ? dataItem.waterMark || `仅限${dataItem.createUserName}查看`
              : `仅限${dataItem.createUserName}查看`;
          let file;
          if (record.files && record.files.length > 0) {
            file = record.files[0];
          } else {
            file = record;
          }
          return (
            <div key={record.url}>
              <a onClick={() => queryFilePreview(file, waterMark)}>{record.no}</a>
            </div>
          );
        },
      },
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '所属公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '所属资料库',
        dataIndex: 'database',
        key: 'database',
      },
      {
        title: '文件类型',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: '文件有效期',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => {
          let beginDate = '';
          let endDate = '';
          beginDate = record.beginDate ? moment(record.beginDate).format('YYYY-MM-DD') : '';
          endDate = record.endDate ? moment(record.endDate).format('YYYY-MM-DD') : '永久';
          return (
            <span>
              {beginDate}至{endDate}
            </span>
          );
        },
      },
      {
        title: '管理员',
        dataIndex: 'manager',
        key: 'manager',
      },
      {
        title: '总量/库存',
        dataIndex: 'amount',
        key: 'amount',
        render: (text, record) => {
          return `${record.amount}/${record.number}`;
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          switch (text) {
            case 1:
              return '有效';
            case 0:
              return '无效';
            default:
          }
        },
      },
    ];
  };

  render() {
    const { dataItem } = this.state;
    return (
      <div className="form-open">
        <Card title="资料借用详情">
          <DescriptionList size="large" col={3}>
            <Description term="资料借用流水">{dataItem.no}</Description>
            <Description term="资料借用申请人">{dataItem.createUserName}</Description>
            {/* <Description term="资料借用公司">{dataItem.company}</Description> */}
            <Description term="借用类型">{+dataItem.type ? '电子版' : '纸质原件'}</Description>
            {+dataItem.type ? (
              <Description term="水印文字">{dataItem.waterMark}</Description>
            ) : null}
            {+dataItem.type ? null : <Description term="借用数量">{dataItem.number}</Description>}
            {+dataItem.type ? null : (
              <Description term="约定归还">
                {moment(dataItem.expectReturnDate).format('YYYY-MM-DD')}
              </Description>
            )}
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="资料借用说明">{dataItem.reason}</Description>
          </DescriptionList>

          <Table
            columns={this.columns()}
            dataSource={[dataItem.document]}
            pagination={false}
            rowKey="uuid"
            style={{ marginTop: '10px' }}
          />
        </Card>
      </div>
    );
  }
}

export default Open;



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/FormOpen.js